var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55556 0C0.692222 0 0 0.692222 0 1.55556V12.4444C0 12.857 0.163888 13.2527 0.455612 13.5444C0.747335 13.8361 1.143 14 1.55556 14H12.4444C12.857 14 13.2527 13.8361 13.5444 13.5444C13.8361 13.2527 14 12.857 14 12.4444V7H12.4444V12.4444H1.55556V1.55556H7V0H1.55556ZM11.4956 0.777778C11.3633 0.777778 11.2233 0.832222 11.1222 0.933333L10.1733 1.87444L12.1178 3.81889L13.0667 2.87778C13.2689 2.67556 13.2689 2.33333 13.0667 2.13889L11.8611 0.933333C11.76 0.832222 11.6278 0.777778 11.4956 0.777778ZM9.62111 2.42667L3.88889 8.16667V10.1111H5.83333L11.5656 4.37111L9.62111 2.42667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNote);
export default __webpack_public_path__ + "static/media/edit-note.a3df04c1.svg";
export { ForwardRef as ReactComponent };